export default __webpack_public_path__ + "static/media/s-logo.c09b2957.png";